export default "__VITE_ASSET__Kh58tVt4n5KhrQqpthGlLg__"